import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock } from "@phosphor-icons/react";
import { BLOG_POSTS } from "../data/site";
import { Reveal, Eyebrow } from "../components/Reveal";
import { CTABand } from "../components/CTABand";

export default function Blog() {
  return (
    <main data-testid="blog-page">
      <section className="border-b border-border bg-secondary/40 pb-16 pt-40 sm:pb-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal y={20}>
            <Eyebrow>Blog</Eyebrow>
            <h1 className="mt-4 max-w-3xl font-display text-5xl font-light leading-[1.02] tracking-tight sm:text-6xl lg:text-7xl">
              Notes from the <em className="text-primary">clinic.</em>
            </h1>
            <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-muted-foreground">
              Updated every month — treatment insights, training diaries and skin wisdom from the DK team.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-24">
        <div className="grid grid-cols-1 gap-12">
          {BLOG_POSTS.map((post, i) => (
            <Reveal key={post.id} delay={0.05 * i}>
              <Link
                to={`/blog/${post.id}`}
                className="group grid grid-cols-1 gap-8 border border-border bg-background transition-colors duration-500 hover:border-primary/40 md:grid-cols-12"
                data-testid={`blog-card-${post.id}`}
              >
                <div className="overflow-hidden md:col-span-5">
                  <motion.img
                    src={post.image}
                    alt={post.title}
                    className="aspect-[16/10] h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col justify-center p-8 md:col-span-7 md:p-12">
                  <div className="flex items-center gap-4 text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
                    <span className="text-primary">{post.date}</span>
                    <span>·</span>
                    <span>{post.author}</span>
                    <span className="flex items-center gap-1.5"><Clock size={13} /> {post.readTime}</span>
                  </div>
                  <h2 className="mt-4 font-display text-3xl font-light tracking-tight transition-colors duration-300 group-hover:text-primary sm:text-4xl">
                    {post.title}
                  </h2>
                  <p className="mt-4 max-w-xl text-sm font-light leading-relaxed text-muted-foreground sm:text-base">
                    {post.excerpt}
                  </p>
                  <span className="mt-6 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-primary">
                    Read the entry
                    <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="mt-14 border-t border-border pt-8 text-center text-xs uppercase tracking-[0.3em] text-muted-foreground" data-testid="blog-monthly-note">
            A new entry is published every month — check back soon.
          </p>
        </Reveal>
      </section>

      <CTABand />
    </main>
  );
}
